import { render, staticRenderFns } from "./SumAssured.vue?vue&type=template&id=688f5e1f"
import script from "./SumAssured.vue?vue&type=script&lang=js"
export * from "./SumAssured.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports